import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useAlerts from '../hooks/alerts';
import Button from 's2s-button';
import {
    FaChevronLeft,
} from 'react-icons/fa';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';
import { withTheme } from 'styled-components';

const AlertsContainer = styled.div`
    background-color: ${({ theme }) => theme.background};
    display: block;
    min-height: calc(100vh - 50px);
    min-width: 320px;
    margin-top: -1px;
`;

const HeaderStyle = styled.div`
    align-items: center;
    background: #1878C7;
    color: ${({ theme }) => theme.header.color};
    display: flex;
    font-size: 16px;
    height: 48px;
    justify-content: space-between;
    font-weight: bold;
`;

const CenteringDiv = styled.div`
  background-color: transparent;
  border: none;
  border-radius: 0px;
  height: 48px;
  margin-right: 0px;
  padding: 0px;
  width: 48px;
`;

const BtnContainer = styled(CenteringDiv)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  :hover{
    background-color: #43A2F0;
  }

  :focus{
     background-color: #3694e0;
  }
`;

const ClearAllBtnContainer = styled(Button)`
  display: flex;
  align-items: center;
  background: transparent;
  justify-content: center;
  cursor: pointer;

  :hover{
    background-color: #43A2F0;
  }

  :focus{
     background-color: #3694e0;
  }
`;

const AlertListWrapper = styled.div`
  display: block;
  overflow-y: scroll;
  min-height: calc(100vh - 98px);
  max-height: calc(100vh - 98px);
  
  &::-webkit-scrollbar {
    width: 6px;
    background-color: ${({ theme }) => theme.header.subheader.background};
  } 
  
  &::-webkit-scrollbar-thumb {
    background-color: #f2f2f2;
  }
`;

const AlertsNav = withTheme(injectIntl((props) => {
  const [alertsState] = useAlerts();
  const { alertHistory } = alertsState;
  const { theme } = props;
  const backButton = (
      <BtnContainer onClick={props.cbBackClick}>
        <FaChevronLeft style={{
        fill: theme.header.fill,
        height: '24px',
        padding: '0',
        width: '24px'
      }} />
      </BtnContainer>
  );
  const clearAllButton = (
      <ClearAllBtnContainer isDisabled={!alertHistory.length}
        svgType="FaTrash"
        svgFill={theme.header.fill}
        cbClick={() => props.cbClearAllClick()}/>
  );

  // Add intl to children props
  const children = React.Children.map(props.children, (child) => {
    return React.cloneElement(child, {
      intl: props.intl
    });
  });

  return (
    <AlertsContainer>
      <HeaderStyle className="settingsHeader">
        { backButton }
        <div>
          {props.title ? props.title : getIntlText(props.intl, 'HEADER-ALERTS-TITLE', "Alerts")}
        </div>
        { clearAllButton }
      </HeaderStyle>
      <AlertListWrapper>
        { children }
      </AlertListWrapper>
    </AlertsContainer>
  );
}));

AlertsNav.propTypes = {
  cbBackClick: PropTypes.func,
  cbClearAllClick: PropTypes.func,
  intl: PropTypes.object,
  title: PropTypes.string
};

//title defaults to undefined because we can not default it to an internationalized value (due to lacking props.intl)
AlertsNav.defaultProps = {
  cbBackClick: () => { console.log("Please define a callback function for cbBackClick in the settings component"); },
  cbClearAllClick: () => { console.log("Please define a callback function for cbClearAllClick in the settings component"); },
  title: undefined
};
export default AlertsNav;
